<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <Coffee /> -->
  </div>
</template>

<script>
// import Coffee from "vue-material-design-icons/Coffee.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCoffee } from "@mdi/js"

export default {
  name: "CoffeeIcon",
  components: {
    SvgIcon
    // Coffee,
  },
  data() {
    return {
      path: mdiCoffee,
    }
  }
}
</script>
